/**
 * New Receipt Button Component
 *
 * Dropdown button to create a new goods receipt.
 * Options: from an existing order or free receipt.
 * Uses callbacks to trigger URL navigation (deep linking).
 */

import { Plus, ChevronDown, FileText, Package } from 'lucide-react';
import { Button } from '@/components/ui';
import { Dropdown, DropdownItem } from '@/components/ui';

interface NewReceiptButtonProps {
  onOpenFreeReceipt: () => void;
  onOpenFromOrder: () => void;
}

export function NewReceiptButton({
  onOpenFreeReceipt,
  onOpenFromOrder,
}: NewReceiptButtonProps) {
  return (
    <Dropdown
      trigger={
        <Button>
          <Plus className="w-4 h-4" />
          Nouvelle reception
          <ChevronDown className="w-4 h-4" />
        </Button>
      }
      align="right"
    >
      <DropdownItem icon={<FileText className="w-4 h-4" />} onClick={onOpenFromOrder}>
        A partir d'une commande
      </DropdownItem>
      <DropdownItem icon={<Package className="w-4 h-4" />} onClick={onOpenFreeReceipt}>
        Reception libre
      </DropdownItem>
    </Dropdown>
  );
}
